import { useState, useEffect } from 'react';
import { Table, Button, Modal, Tag, Space, Popconfirm, message, Badge } from 'antd';
import { DeleteOutlined, EyeOutlined, MailOutlined } from '@ant-design/icons';
import API from '../api/client';

const ContactMessagesPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewModal, setViewModal] = useState({ open: false, record: null });

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await API.get('/contact-messages');
      setData(res.data);
    } catch { message.error('Mesajlar yüklenemedi'); }
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, []);

  const handleView = async (record) => {
    setViewModal({ open: true, record });
    if (!record.read) {
      await API.put(`/contact-messages/${record._id}/read`);
      setData(prev => prev.map(m => m._id === record._id ? { ...m, read: true } : m));
    }
  };

  const handleDelete = async (id) => {
    await API.delete(`/contact-messages/${id}`);
    message.success('Mesaj silindi');
    fetchData();
  };

  const unreadCount = data.filter(m => !m.read).length;

  const columns = [
    {
      title: 'Durum', dataIndex: 'read', key: 'read', width: 80,
      render: (read) => read
        ? <Tag color="default">Okundu</Tag>
        : <Tag color="blue">Yeni</Tag>,
    },
    { title: 'Ad Soyad', dataIndex: 'name', key: 'name' },
    { title: 'E-posta', dataIndex: 'email', key: 'email' },
    { title: 'Konu', dataIndex: 'subject', key: 'subject', render: (v) => v || '-' },
    {
      title: 'Tarih', dataIndex: 'createdAt', key: 'createdAt', width: 160,
      render: (v) => v ? new Date(v).toLocaleString('tr-TR', {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
      }) : '-',
    },
    {
      title: 'İşlem', key: 'actions', width: 120,
      render: (_, record) => (
        <Space>
          <Button icon={<EyeOutlined />} size="small" onClick={() => handleView(record)} />
          <Popconfirm title="Silmek istediğinize emin misiniz?" onConfirm={() => handleDelete(record._id)}>
            <Button icon={<DeleteOutlined />} size="small" danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>
          <MailOutlined style={{ marginRight: 8 }} />
          Gelen Mesajlar
          {unreadCount > 0 && (
            <Badge count={unreadCount} style={{ marginLeft: 12 }} />
          )}
        </h2>
      </div>

      <Table
        columns={columns}
        dataSource={data}
        rowKey="_id"
        loading={loading}
        rowClassName={(record) => record.read ? '' : 'unread-row'}
      />

      <Modal
        title="Mesaj Detayı"
        open={viewModal.open}
        onCancel={() => setViewModal({ open: false, record: null })}
        footer={[
          <Button key="close" onClick={() => setViewModal({ open: false, record: null })}>
            Kapat
          </Button>,
          viewModal.record?.email && (
            <Button key="reply" type="primary" href={`mailto:${viewModal.record.email}`}>
              Yanıtla
            </Button>
          ),
        ]}
        width={600}
      >
        {viewModal.record && (
          <div style={{ lineHeight: 2 }}>
            <p><strong>Ad Soyad:</strong> {viewModal.record.name}</p>
            <p><strong>E-posta:</strong> <a href={`mailto:${viewModal.record.email}`}>{viewModal.record.email}</a></p>
            {viewModal.record.phone && <p><strong>Telefon:</strong> <a href={`tel:${viewModal.record.phone}`}>{viewModal.record.phone}</a></p>}
            {viewModal.record.subject && <p><strong>Konu:</strong> {viewModal.record.subject}</p>}
            <p><strong>Tarih:</strong> {new Date(viewModal.record.createdAt).toLocaleString('tr-TR')}</p>
            <div style={{
              marginTop: 16,
              padding: 16,
              background: '#f5f5f5',
              borderRadius: 8,
              whiteSpace: 'pre-wrap',
              fontSize: 14,
              lineHeight: 1.7,
            }}>
              {viewModal.record.message}
            </div>
          </div>
        )}
      </Modal>

      <style>{`
        .unread-row { background: #f0f5ff !important; font-weight: 500; }
        .unread-row:hover td { background: #e6f0ff !important; }
      `}</style>
    </>
  );
};

export default ContactMessagesPage;
